<template>
  <div>
    <v-app-bar flat dense>
      <!-- <v-toolbar-title>Spacepack</v-toolbar-title> -->
      <img
        id="logo"
        :src="logoUrl"
        style="height: 60%; cursor: pointer"
        class="ml-4"
        @click="redirectHome"
      />
    </v-app-bar>
    <v-container v-if="payment">
      <v-row>
        <v-col cols="12" md="8" sm="12">
          <p class="mt-4 mb-8 mx-12 mt-4 title">Checkout Details</p>
          <v-card class="mx-4 card-container" elevation="0">
            <v-stepper v-model="step" class="elevation-0 px-8 py-8">
              <v-stepper-header class="elevation-0">
                <v-stepper-step :complete="step > 1" step="1">
                  Billing Details
                  <!-- <small>Summarize if needed</small> -->
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 2" step="2">
                  Select Payment Option
                  <!-- <small>Summarize if needed</small> -->
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 3" step="3">
                  Confirm Payment
                  <!-- <small>Summarize if needed</small> -->
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-content step="1" class="pt-0">
                <!-- <v-card color="grey lighten-1" class="mb-12" height="200px" width="500px"></v-card> -->
                <v-form ref="form" v-model="billingForm">
                  <v-row>
                    <v-col cols="12" md="12">
                      <p class="subtitle-2 mb-2">Name</p>
                      <v-text-field
                        v-model="tenantName"
                        dense
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12">
                      <p class="subtitle-2 mb-2">Address Line 1</p>
                      <v-text-field
                        v-model="billing.address1"
                        dense
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12">
                      <p class="subtitle-2 mb-2">Address Line 2</p>
                      <v-text-field
                        v-model="billing.address2"
                        dense
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <p class="subtitle-2 mb-2">City</p>
                      <v-text-field
                        v-model="billing.city"
                        dense
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <p class="subtitle-2 mb-2">Postal Code</p>
                      <v-text-field
                        v-model="billing.postalCode"
                        dense
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12">
                      <p class="subtitle-2 mb-2">Contact Number</p>
                      <v-text-field
                        v-model="billing.contactNumber1"
                        dense
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
                <div class="mt-6">
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-btn
                        text
                        large
                        outlined
                        block
                        class="mr-2"
                        @click="step = 1"
                        >Cancel</v-btn
                      >
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-btn
                        color="#5ebf9a"
                        large
                        dark
                        block
                        depressed
                        @click="step = 2"
                        >Continue</v-btn
                      >
                    </v-col>
                  </v-row>
                </div>
              </v-stepper-content>

              <v-stepper-content step="2" class="pt-0">
                <!-- <v-card color="grey lighten-1" class="mb-12" height="200px" width="500px"></v-card> -->
                <v-tabs v-model="paymentOption" centered height="100">
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab href="#credit-card">
                    <v-card outlined class="px-md-8 py-md-4 d-flex flex-column">
                      <v-icon>mdi-credit-card</v-icon>
                      Credit Card
                    </v-card>
                  </v-tab>
                  <v-tab href="#e-wallet">
                    <v-card outlined class="px-md-8 py-md-4 d-flex flex-column">
                      <v-icon>mdi-wallet</v-icon>
                      E-Wallet
                    </v-card>
                  </v-tab>
                </v-tabs>

                <v-tabs-items v-model="paymentOption">
                  <v-tab-item value="credit-card">
                    <v-card flat>
                      <v-form ref="form" v-model="creditCardForm">
                        <v-row>
                          <v-col cols="12" md="12">
                            <p class="subtitle-2 mb-2">Cardholder's Name</p>
                            <v-text-field
                              v-model="creditCard.name"
                              dense
                              outlined
                              hide-details
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6">
                            <p class="subtitle-2 mb-2">Card Number</p>
                            <v-text-field
                              v-model="creditCard.number"
                              v-mask="'####  ####  ####  ####'"
                              dense
                              outlined
                              hide-details
                            >
                              <template v-slot:append>
                                <img
                                  contain
                                  :src="paymentLogo"
                                  style="height: 25px; object-fit: scale-down"
                                />
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="3">
                            <p class="subtitle-2 mb-2">Expiration</p>
                            <v-text-field
                              v-model="creditCard.expiration"
                              v-mask="'##/##'"
                              dense
                              outlined
                              hide-details
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="3">
                            <p class="subtitle-2 mb-2">CVV</p>
                            <v-text-field
                              v-model="creditCard.cvv"
                              v-mask="'###'"
                              dense
                              outlined
                              hide-details
                            >
                              <template v-slot:append>
                                <img
                                  contain
                                  :src="cvvLogo"
                                  style="height: 25px; object-fit: scale-down"
                                />
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-card>
                    <v-divider class="my-4"></v-divider>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-btn
                          text
                          outlined
                          large
                          class="mr-2"
                          block
                          @click="step = 1"
                          >Back</v-btn
                        >
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-btn
                          color="#5ebf9a"
                          dark
                          large
                          depressed
                          block
                          @click="confirmPayment"
                        >
                          <v-icon small class="mr-2">mdi-lock</v-icon>Confirm
                          Payment:
                          {{ formatCurrency(totalAfterProcess) }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <v-tab-item value="e-wallet">
                    <v-card class="mt-8" flat>
                      <v-row>
                        <v-col
                          class="d-flex justify-center"
                          cols="12"
                          md="6"
                          sm="12"
                        >
                          <v-btn
                            block
                            x-large
                            depressed
                            color="#2c6ee7"
                            dark
                            class="text-none"
                          >
                            Pay with
                            <img
                              class="ml-2"
                              :src="gcashLogo"
                              style="height: 30px"
                            />
                          </v-btn>
                        </v-col>
                        <v-col
                          class="d-flex justify-center"
                          cols="12"
                          md="6"
                          sm="12"
                        >
                          <v-btn
                            block
                            x-large
                            depressed
                            color="#5ebf9a"
                            dark
                            class="text-none"
                          >
                            Pay with
                            <img
                              class="ml-2"
                              :src="grabpayLogo"
                              style="height: 25px"
                            />
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-btn
                            text
                            large
                            outlined
                            block
                            class="mr-2"
                            @click="step = 1"
                            >Back</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-card>
                    <!-- <div class="mt-6">
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-btn text @click="step = 1" large outlined block class="mr-2">Back</v-btn>
                        </v-col>
                        <v-col cols="12" md="8">
                          <v-btn color="#5ebf9a" @click="step = 3" large dark block>Continue</v-btn>
                        </v-col>
                      </v-row>
                    </div> -->
                  </v-tab-item>
                </v-tabs-items>
              </v-stepper-content>

              <v-stepper-content step="3" class="pt-0">
                <!-- <v-card color="grey lighten-1" class="mb-12" height="200px" width="500px"></v-card> -->
                <div class="d-flex justify-center">
                  <table class="summary-table" style="width: 70%">
                    <tr>
                      <td><p class="caption">Payment to</p></td>
                      <td>
                        <p class="caption font-weight-bold text-right">
                          {{ payment.property_details.propertyName }}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td><p class="caption">Payment mode</p></td>
                      <td>
                        <p class="caption font-weight-bold text-right">
                          {{ paymentNiceType }}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="caption">Credit Card / Account Number</p>
                      </td>
                      <td>
                        <p class="caption font-weight-bold text-right">
                          {{ creditCard.number }}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td><p class="caption">Amount</p></td>
                      <td>
                        <p class="caption font-weight-bold text-right">
                          {{ formatCurrency(payment.total) }}
                        </p>
                      </td>
                    </tr>
                    <tr class="pa-2">
                      <td><p class="caption">Process Fee</p></td>
                      <td>
                        <p class="caption font-weight-bold text-right">
                          {{ processFeeAmount }}
                        </p>
                      </td>
                    </tr>
                    <br />
                    <tr class="pa-2">
                      <td><p class="subtitle-2">Total</p></td>
                      <td><p class="title text-right">Php 1,120.00</p></td>
                    </tr>
                  </table>
                </div>
                <v-divider class="my-4"></v-divider>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-btn
                      text
                      outlined
                      large
                      class="mr-2"
                      block
                      @click="step = 2"
                      >Back</v-btn
                    >
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-btn
                      color="#5ebf9a"
                      dark
                      large
                      depressed
                      block
                      @click="confirmPayment"
                    >
                      <v-icon small class="mr-2">mdi-lock</v-icon>Confirm
                      Payment: Php 1,120.00
                    </v-btn>
                  </v-col>
                </v-row>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" sm="12">
          <v-card class="my-12 mx-4 card-container pa-12" elevation="0">
            <p class="subtitle-2 mb-4">About your payment</p>
            <!-- <p class="caption">Amount</p> -->
            <table class="summary-table" style="width: 100%">
              <tr>
                <td><p class="caption">Property</p></td>
                <td>
                  <p class="caption font-weight-bold text-right">
                    {{ payment.property_details.propertyName }}
                  </p>
                </td>
              </tr>
              <tr class="pa-2">
                <td><p class="caption">Item</p></td>
                <td>
                  <p class="caption font-weight-bold text-right">
                    {{
                      categories.find((cat) => cat.value == payment.category)
                        .text
                    }}
                  </p>
                </td>
              </tr>
              <tr class="pa-2">
                <td><p class="caption">Status</p></td>
                <td v-if="payment.status != 'pending'">
                  <p class="caption font-weight-bold text-right">
                    {{ payment.status }}
                  </p>
                </td>
                <td v-else>
                  <p class="caption font-weight-bold text-right red--text">
                    Pending
                  </p>
                </td>
              </tr>
            </table>
          </v-card>

          <v-card class="my-4 mx-4 card-container pa-12" elevation="0">
            <p class="subtitle-2 mb-4">Order Summary</p>
            <!-- <p class="caption">Amount</p> -->
            <table class="summary-table" style="width: 100%">
              <tr>
                <td><p class="caption">Amount</p></td>
                <td>
                  <p class="subtitle-2 text-right">
                    {{ formatCurrency(payment.total) }}
                  </p>
                </td>
              </tr>
              <tr class="pa-2">
                <td>
                  <p class="caption">Process Fee ({{ processFeeText }})</p>
                </td>
                <td>
                  <p class="caption text-right">
                    {{ formatCurrency(processFeeAmount) }}
                  </p>
                </td>
              </tr>
            </table>
            <v-divider class="my-4"></v-divider>
            <table class="summary-table" style="width: 100%">
              <tr class="pa-2">
                <td>
                  <p class="subtitle-2">Total</p>
                  <p class="caption">(Incl. VAT)</p>
                </td>
                <td>
                  <p class="title text-right">
                    {{ formatCurrency(totalAfterProcess) }}
                  </p>
                </td>
              </tr>
            </table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import creditCardType from 'credit-card-type'
import visa from 'payment-icons/min/flat/visa.svg'
import mastercard from 'payment-icons/min/flat/mastercard.svg'
import cvv from 'payment-icons/min/flat/security-code.svg'
import defaultCC from 'payment-icons/min/mono/default.svg'

export default {
  props: ['objectId'],
  data() {
    return {
      step: 1,
      billingForm: false,
      paymentOption: '',
      creditCardForm: true,
      creditCard: {
        name: '',
        number: '',
        expiration: '',
        cvv: ''
      },
      paymentType: '',
      paymentNiceType: '',
      payment: null,
      categories: [
        {
          text: 'Rent Fee',
          value: 'rent'
        },
        {
          text: 'Utility (Water)',
          value: 'utilities_water'
        },
        {
          text: 'Utility (Electricity)',
          value: 'utilities_electricity'
        },
        {
          text: 'Miscellaneous',
          value: 'misc'
        },
        {
          text: 'Violation',
          value: 'violation'
        },
        {
          text: 'Reservation',
          value: 'reservation'
        }
      ]
    }
  },
  computed: {
    logoUrl() {
      return `${process.env.BASE_URL}images/logo-wide.png`
    },
    creditCardNumber() {
      return this.creditCard.number
    },
    paymentLogo() {
      switch (this.paymentType) {
        case 'visa':
          return visa
        case 'mastercard':
          return mastercard
        default:
          return defaultCC
      }
    },
    cvvLogo() {
      return cvv
    },
    gcashLogo() {
      return `${process.env.BASE_URL}images/wallet/gcash.png`
    },
    grabpayLogo() {
      return `${process.env.BASE_URL}images/wallet/grabpay.png`
    },
    tenantName() {
      const firstName = this.payment.tenant_details.firstName
      const lastName = this.payment.tenant_details.lastName
      if (firstName) {
        if (lastName) {
          return `${firstName} ${lastName}`
        }
        return firstName
      }
      return ''
    },
    billing() {
      return this.payment.tenant_details
    },
    processFeeText() {
      if (this.paymentOption == 'credit-card') {
        return '3.5% + P15'
      } else if (this.paymentOption == 'e-wallet') {
        return '2.9%'
      }
      return 0
    },
    processFeeAmount() {
      if (this.paymentOption == 'credit-card') {
        return 0.035 * this.payment.total + 15
      } else if (this.paymentOption == 'e-wallet') {
        return 0.029 * this.payment.total
      }
      return this.payment.total
    },
    totalAfterProcess() {
      if (this.paymentOption == 'credit-card') {
        return (1 + 0.035) * this.payment.total + 15
      } else if (this.paymentOption == 'e-wallet') {
        return (1 + 0.029) * this.payment.total
      }
      return this.payment.total
    }
  },
  watch: {
    creditCardNumber: {
      handler(val) {
        if (val.length >= 4) {
          const cc = creditCardType(val)[0]
          if (cc) {
            this.paymentType = cc.type
            this.paymentNiceType = cc.niceType
          } else {
            this.paymentType = ''
          }
        } else {
          this.paymentType = ''
        }
      },
      immediate: true
    }
  },
  async created() {
    this.payment = await this.$store.dispatch(
      'payments/fetchPaymentByObjectIdAction',
      {
        objectId: this.objectId
      }
    )
  },
  methods: {
    redirectHome() {},
    confirmPayment() {},
    formatCurrency(value) {
      if (value == null) return ''
      return parseFloat(value / 100).toLocaleString('en-PH', {
        style: 'currency',
        currency: 'PHP'
      })
    }
  }
}
</script>

<style scoped>
.card-container {
  border-radius: 12px !important;
}

.summary-table td {
  height: 30px;
}
</style>
